export enum ServiceTypes {
    Load = 1,
    Unload = 2,
    LogisticsAssistant = 3,
}